exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-box{position:fixed;display:flex;top:0;left:0;right:0;bottom:0;visibility:hidden;opacity:0;transition:all .3s ease;overflow:auto;z-index:999}@media (max-width:834px){.modal-box{flex-direction:column}}.modal-box.open{visibility:visible;opacity:1}.modal-box .mask{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(33,33,33,.5);z-index:-1}.modal-box .box{position:relative;margin:auto;border-radius:12px;padding:40px 48px 24px;width:405px;max-width:90%;min-height:400px;text-align:center;background:#fff;transition:all .3s ease}.modal-box .box img{max-width:100%}", ""]);

// exports
